import { useFragment } from '@apollo/client';
import { matchPath } from 'react-router';
import type { ProductFamilyFieldsFragment } from '../../__generated__/graphql-client-types';
import { PRODUCT_PREFIX, PRODUCT_SUMMARY_ROUTE } from '../../constants/links';
import { ProductFamilyFields } from '../../queries/product/product-family-fragment.queries';
import { matchPrefixedRoute } from '../../utils/routing/route.utils';
import { useRouterLocation } from '../routing/location.hook';

// Returns a PED specific phone number if the current page is a product page (PLA/PDP) and
// the product is marked as a PED product in our config.
export const usePEDProductPhone = () => {
	const { pathname } = useRouterLocation();
	const [, pdpId] = matchPrefixedRoute(pathname, PRODUCT_PREFIX);
	const plaMatch = matchPath(PRODUCT_SUMMARY_ROUTE, pathname);
	const productId = pdpId || plaMatch?.params.familyId;

	const { data } = useFragment<ProductFamilyFieldsFragment>({
		from: {
			__typename: 'ProductFamily',
			id: productId
		},
		fragment: ProductFamilyFields,
		fragmentName: 'ProductFamilyFields'
	});

	return data?.pedProductPhone;
};
